import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ICompanionsData, ICompanionsDataLimit, IFieldValue, IRegistrationField, MULTIVALUE_TYPES } from '../../registration-form.service';

const TEXT_TYPES = ['text', 'textarea'];

@Component({
  selector: 'edit-registration-field-companions',
  templateUrl: './edit-registration-field-companions.component.html',
  styleUrls: ['./edit-registration-field-companions.component.scss'],
})
export class EditRegistrationFieldCompanionsComponent implements OnInit, OnChanges {
  @Input() companionsData: ICompanionsData | null = null;
  @Input() allFields: IRegistrationField[] = [];
  @Output() companionsDataChanged = new EventEmitter<ICompanionsData | null>();

  public companionsOptions: 'global' | 'conditional' | 'individual' = 'global';
  public globalValue: number | null = null;
  public linkedOptionId: number | null = null;
  public limits: ICompanionsDataLimit[] = [];
  public numberOptionId: number | null = null;

  // Add limit modal
  public showAddLimitModal = false;
  public modalOptionValueId: number | null = null;
  public modalLimitValue: number | null = null;

  ngOnInit() {
    this.initFromInput();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.companionsData) {
      this.initFromInput();
    }
  }

  private initFromInput() {
    if (this.companionsData) {
      this.companionsOptions = this.companionsData.companions_options || 'global';
      this.globalValue = this.companionsData.global_value != null ? this.companionsData.global_value : null;
      this.linkedOptionId = this.companionsData.linked_option_id != null ? this.companionsData.linked_option_id : null;
      this.limits = this.companionsData.limits ? [...this.companionsData.limits] : [];
      this.numberOptionId = this.companionsData.number_option_id != null ? this.companionsData.number_option_id : null;
    } else {
      this.companionsOptions = 'global';
      this.globalValue = null;
      this.linkedOptionId = null;
      this.limits = [];
      this.numberOptionId = null;
    }
  }

  get customFields(): IRegistrationField[] {
    return this.allFields.filter(f => !f.is_default);
  }

  get multivalueFields(): IRegistrationField[] {
    return this.customFields.filter(f => MULTIVALUE_TYPES.indexOf(f.field_type) >= 0);
  }

  get textFields(): IRegistrationField[] {
    return this.customFields.filter(f => TEXT_TYPES.indexOf(f.field_type) >= 0);
  }

  get linkedOptionLocked(): boolean {
    return this.limits.length > 0;
  }

  get selectedLinkedField(): IRegistrationField | null {
    if (this.linkedOptionId == null) return null;
    return this.customFields.find(f => f.option_id === this.linkedOptionId) || null;
  }

  get linkedFieldValues(): IFieldValue[] {
    const field = this.selectedLinkedField;
    return (field && field.values) ? field.values : [];
  }

  getLimitLabel(optionValueId: number): string {
    const val = this.linkedFieldValues.find(v => v.option_value_id === optionValueId);
    return val ? val.label : String(optionValueId);
  }

  onCompanionsOptionsChange() {
    this.emit();
  }

  onLinkedOptionChange() {
    this.limits = [];
    this.emit();
  }

  emit() {
    let data: ICompanionsData;
    if (this.companionsOptions === 'global') {
      data = { companions_options: 'global', global_value: this.globalValue != null ? this.globalValue : undefined };
    } else if (this.companionsOptions === 'conditional') {
      data = {
        companions_options: 'conditional',
        linked_option_id: this.linkedOptionId != null ? this.linkedOptionId : undefined,
        limits: [...this.limits],
      };
    } else {
      data = { companions_options: 'individual', number_option_id: this.numberOptionId != null ? this.numberOptionId : undefined };
    }
    this.companionsDataChanged.emit(data);
  }

  // Add limit modal

  openAddLimitModal() {
    this.modalOptionValueId = null;
    this.modalLimitValue = null;
    this.showAddLimitModal = true;
  }

  closeAddLimitModal() {
    this.showAddLimitModal = false;
  }

  saveLimit() {
    if (this.modalOptionValueId == null || this.modalLimitValue == null) return;
    this.limits = [...this.limits, { option_value_id: this.modalOptionValueId, limit: this.modalLimitValue }];
    this.closeAddLimitModal();
    this.emit();
  }

  removeLimit(index: number) {
    this.limits = this.limits.filter((_, i) => i !== index);
    this.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/registration-form/edit-registration-field-companions/edit-registration-field-companions.component.ts